document.addEventListener('DOMContentLoaded', () => {
  let currentColor = '';

  function enhanceMobileCarouselNavigation() {
    if (window.innerWidth >= 1000) return;

    const carouselNavigations = document.querySelectorAll('carousel-navigation.scroll-marker-group--dots');

    carouselNavigations.forEach(navigation => {
      const carouselId = navigation.getAttribute('aria-controls');

      let carousel = carouselId ? document.getElementById(carouselId) : null;

      if (!carousel) {
        const productGallery = navigation.closest('product-gallery');
        if (productGallery) {
          carousel = productGallery.querySelector('scroll-carousel');
        }
      }

      if (!carousel) {
        const allCarousels = document.querySelectorAll('scroll-carousel');
        if (allCarousels.length === 1) {
          carousel = allCarousels[0];
        }
      }

      if (!carousel) {
        console.warn('Could not find carousel for navigation', navigation);
        return;
      }

      if (typeof carousel.select !== 'function') {
        console.warn('Carousel does not have select method', carousel);
        return;
      }

      const dots = navigation.querySelectorAll('.scroll-marker');
      if (!dots.length) {
        console.warn('No dots found in navigation', navigation);
        return;
      }

      const visibleCells = Array.from(carousel.querySelectorAll('.product-gallery__media:not([hidden])'));

      for (let i = 0; i < dots.length; i++) {
        if (i < visibleCells.length) {
          dots[i].removeAttribute('hidden');
        } else {
          dots[i].setAttribute('hidden', 'true');
        }
      }

      const initialSlideIndex = visibleCells.findIndex(cell => cell.classList.contains('is-initial'));

      if (initialSlideIndex >= 0) {
        dots.forEach((dot, index) => {
          dot.setAttribute('aria-current', index === initialSlideIndex ? 'true' : 'false');
        });
      } else if (visibleCells.length > 0) {
        dots.forEach((dot, index) => {
          dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
        });
      }

      dots.forEach((dot, index) => {
        const newDot = dot.cloneNode(true);
        dot.parentNode.replaceChild(newDot, dot);

        newDot.addEventListener('click', (event) => {
          event.preventDefault();

          try {
            carousel.select(index, { instant: false });
          } catch (error) {
            console.error('Error selecting carousel slide:', error);

            const slides = carousel.querySelectorAll('.product-gallery__media:not([hidden])');
            if (slides[index]) {
              slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
            }
          }

          const currentDots = navigation.querySelectorAll('.scroll-marker');
          currentDots.forEach((d, i) => {
            d.setAttribute('aria-current', i === index ? 'true' : 'false');
          });
        });
      });

      carousel.addEventListener('scroll', () => {
        const slides = Array.from(carousel.querySelectorAll('.product-gallery__media:not([hidden])'));
        if (!slides.length) return;

        const scrollLeft = carousel.scrollLeft;
        const containerWidth = carousel.clientWidth;

        let closestIndex = 0;
        let closestDistance = Infinity;

        slides.forEach((slide, index) => {
          const slideLeft = slide.offsetLeft;
          const slideCenter = slideLeft + (slide.clientWidth / 2);
          const containerCenter = scrollLeft + (containerWidth / 2);
          const distance = Math.abs(slideCenter - containerCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        const currentDots = navigation.querySelectorAll('.scroll-marker');
        currentDots.forEach((dot, index) => {
          dot.setAttribute('aria-current', index === closestIndex ? 'true' : 'false');
        });
      });
    });
  }

  enhanceMobileCarouselNavigation();

  window.addEventListener('resize', () => {
    enhanceMobileCarouselNavigation();
  });

  document.addEventListener('variant:change', (e) => {
    if (window.innerWidth >= 1000) return;

    const variant = e.detail.variant;
    const newColor = variant.option1?.toLowerCase();

    const colorChanged = newColor !== currentColor;
    currentColor = newColor;

    setTimeout(() => {
      enhanceMobileCarouselNavigation();

      if (colorChanged) {
        const carouselNavigations = document.querySelectorAll('carousel-navigation.scroll-marker-group--dots');

        carouselNavigations.forEach(navigation => {
          const carouselId = navigation.getAttribute('aria-controls');
          let carousel = carouselId ? document.getElementById(carouselId) : null;

          if (!carousel) {
            const productGallery = navigation.closest('product-gallery');
            if (productGallery) {
              carousel = productGallery.querySelector('scroll-carousel');
            }
          }

          if (!carousel) {
            const allCarousels = document.querySelectorAll('scroll-carousel');
            if (allCarousels.length === 1) {
              carousel = allCarousels[0];
            }
          }

          if (carousel && typeof carousel.select === 'function') {
            carousel.select(0, { instant: true });

            const dots = navigation.querySelectorAll('.scroll-marker');
            dots.forEach((dot, index) => {
              dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
            });
          }
        });
      }
    }, 100);
  });

  window.addEventListener('load', () => {
    enhanceMobileCarouselNavigation();
  });
});